module.exports = __webpack_public_path__ + "img/54bf15b.png";